import { Type } from "@angular/core";
import { Observable } from "rxjs/Observable";

export class UserAccountSetting {
  userId: string;
  contact: ContactInfo;
  security: SecurityInfo;
  isPaycorUser: boolean;
  isPartnerUser: boolean;
  isSsoUser: boolean;
  isOktaSsoUser: boolean;
}

export class SecurityInfo {
  mfaEnabled: boolean;
  sessionTimeout: number;
  sliderTime: number;
  displayTime: DisplayTime;
  ssoIsVisible: boolean;
  username: string;
  isMergeLinkVisible: boolean;
  cultureInfo:string;
  isLocalizationEnabled: boolean; 
  hasSsoAndPaycorIdentity: boolean;
  sliderTimeInitial: number;
}

export class MfaSettings {
  MfaEnabled: boolean;
  CanChangeMultiFactorAuthentication: boolean;
  PhoneStatus: number;
  EmailStatus: number;
  GoogleAuthenticatorStatus: number;
  MfaStatus: string;
  PhoneChecked: boolean;
  PhoneDisabled: boolean;
  EmailChecked: boolean;
  EmailDisabled: boolean;
  GoogleAuthChecked: boolean;
  GoogleAuthDisabled: boolean;
  MfaSelectedOptions: number;
  MfaErrorMsg: string;
  MfaHasChange: boolean;
  MfaHasErrors: boolean;
  ForceEmailMfaEnabled: boolean;
  PhoneCheckedInitial: boolean;
  EmailCheckedInitial: boolean;
  GoogleAuthCheckedInitial: boolean;
}
export class MfaElectionModal {
  MfaElection: MfaElectionTypeEnum;
  TotpPin: string;
}
export enum MfaElectionTypeEnum {
  None = 0,
  Email = 1,
  Phone = 2,
  GoogleAuthenticator = 3,
  EmailAndPhone = 4,
  EmailAndGoogleAuthenticator = 5,
  PhoneAndGoogleAuthenticator = 6,
  EmailPhoneAndGoogleAuthenticator = 7
}
export class DisplayTime {
  hours: number;
  minutes: number;
}
export class ContactInfo {
  lastName: string;
  firstName: string;
  pendingEmail: string;
  email: string;
  phones: PhoneInfo[];
}

export class PhoneInfo {
  id: number;
  isTextEnabled: boolean;
  number: string;
  phoneType: string;
  verificationStatus: string;
}

export class PhoneVerificationRequest {
  sendAsSms: boolean;
  phoneInfo: PhoneInfo;
}
export class UserAccountSettingView extends UserAccountSetting {
  actionUrls: string[];
}

export class UserNavigationSecurity {
  isPaycorUser: boolean;
  isAuthorizedForMessaging: boolean;
  isPartnerUser: boolean;
  isImpersonated: boolean;
}

export class UserQRCode {
  Base64QrImage: string;
  Secret: string;
}

export class ValidateTotpModal {
  pin: string;
}

export class TranslationProps {
  CultureInfo:string;
  IsLocalizationEnabled: boolean; 
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/my-settings/account/model.ts